// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-container {
  /* background: linear-gradient(#000000b8, #0000009c),
    url("https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=1650&q=80")
      center/cover no-repeat; */
  background: url("https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=1650&q=80")
  center/cover no-repeat;
  background-size: cover;
  min-height: 100vh;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 500;
}
.title {
  font-size: 3rem;
  margin-bottom: 2rem;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.8);
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  width: 100%;
  max-width: 800px;
}

.card {
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 16px;
  padding: 2rem;
  text-align: center;
  cursor: pointer;
  transition: transform 0.3s, background-color 0.3s;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
}

.card:hover {
  background-color: rgba(255, 255, 255, 0.1);
  transform: translateY(-5px);
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal {
  background: rgba(0, 0, 0, 0.85);
  padding: 30px;
  border-radius: 12px;
  text-align: center;
  max-width: 400px;
  width: 90%;
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.modal input {
  padding: 10px;
  width: 100%;
  margin-top: 15px;
  border-radius: 6px;
  border: none;
  font-size: 1rem;
}

.modal-actions {
  margin-top: 20px;
  display: flex;
  gap: 10px;
  justify-content: center;
}

.modal-actions button {
  padding: 10px 20px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 6px;
  border: none;
  transition: all 0.3s ease;
}

.modal-actions .cancel {
  background-color: #ff5555;
  color: white;
}

.modal-actions button:not(.cancel) {
  background-color: #2b7de9;
  color: white;
}

.error {
  color: #ffaaaa;
  margin-top: 10px;
}



/* Responsive Media Queries */
@media (max-width: 1024px) {
  body, .container {
    padding: 1rem;
    font-size: 1rem;
  }
  img, video {
    max-width: 100%;
    height: auto;
  }
}

@media (max-width: 600px) {
  .container, .card, .section, .content {
    flex-direction: column !important;
    width: 100% !important;
    font-size: 0.9rem !important;
    padding: 0.5rem !important;
  }

  h1, h2, h3 {
    font-size: 1.2rem !important;
  }

  nav, header, footer {
    flex-direction: column;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Home.css"],"names":[],"mappings":"AAAA;EACE;;+BAE6B;EAC7B;wBACsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;AACA;;;;;;EAME,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,iDAAiD;EACjD,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;;;AAIA,6BAA6B;AAC7B;EACE;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE;IACE,iCAAiC;IACjC,sBAAsB;IACtB,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF","sourcesContent":[".home-container {\n  /* background: linear-gradient(#000000b8, #0000009c),\n    url(\"https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=1650&q=80\")\n      center/cover no-repeat; */\n  background: url(\"https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=1650&q=80\")\n  center/cover no-repeat;\n  background-size: cover;\n  min-height: 100vh;\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  color: white;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-weight: 500;\n}\n.title {\n  font-size: 3rem;\n  margin-bottom: 2rem;\n  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.8);\n}\n\n.card-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 2rem;\n  width: 100%;\n  max-width: 800px;\n}\n\n.card {\n  background-color: rgba(0, 0, 0, 0.7);\n  border-radius: 16px;\n  padding: 2rem;\n  text-align: center;\n  cursor: pointer;\n  transition: transform 0.3s, background-color 0.3s;\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);\n}\n\n.card:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n  transform: translateY(-5px);\n}\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(4px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n}\n\n.modal {\n  background: rgba(0, 0, 0, 0.85);\n  padding: 30px;\n  border-radius: 12px;\n  text-align: center;\n  max-width: 400px;\n  width: 90%;\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.modal input {\n  padding: 10px;\n  width: 100%;\n  margin-top: 15px;\n  border-radius: 6px;\n  border: none;\n  font-size: 1rem;\n}\n\n.modal-actions {\n  margin-top: 20px;\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n}\n\n.modal-actions button {\n  padding: 10px 20px;\n  font-weight: bold;\n  cursor: pointer;\n  border-radius: 6px;\n  border: none;\n  transition: all 0.3s ease;\n}\n\n.modal-actions .cancel {\n  background-color: #ff5555;\n  color: white;\n}\n\n.modal-actions button:not(.cancel) {\n  background-color: #2b7de9;\n  color: white;\n}\n\n.error {\n  color: #ffaaaa;\n  margin-top: 10px;\n}\n\n\n\n/* Responsive Media Queries */\n@media (max-width: 1024px) {\n  body, .container {\n    padding: 1rem;\n    font-size: 1rem;\n  }\n  img, video {\n    max-width: 100%;\n    height: auto;\n  }\n}\n\n@media (max-width: 600px) {\n  .container, .card, .section, .content {\n    flex-direction: column !important;\n    width: 100% !important;\n    font-size: 0.9rem !important;\n    padding: 0.5rem !important;\n  }\n\n  h1, h2, h3 {\n    font-size: 1.2rem !important;\n  }\n\n  nav, header, footer {\n    flex-direction: column;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
